var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"role":"main"}},[_c('ol',{staticClass:"book-list"},_vm._l((_vm.filteredBooks),function(a){return _c('Book',{key:a.id,attrs:{"book":a}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }